<template>
    <div class="cadre">
        <h3>Recherche du Client</h3>


        <form @submit.prevent="searchClients">
            <div class="row mb-3">
                <div class="col-md-4">
                    <label for="societe">Société</label>
                    <input type="text" class="form-control" id="client_societe" v-model="client.societe" />
                </div>
                <div class="col-md-4">
                    <label for="nom">Nom</label>
                    <input type="text" class="form-control" id="client_nom" v-model="client.nom" />
                </div>
                <div class="col-md-4">
                    <label for="prenom">Prénom</label>
                    <input type="text" class="form-control" id="client_prenom" v-model="client.prenom" />
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-4">
                    <label for="localite">Localité</label>
                    <input type="text" class="form-control" id="client_localite" v-model="client.localite" />
                </div>
                <div class="col-md-4">
                    <label for="codePostal">Code postal</label>
                    <input type="text" class="form-control" id="client_code_postal" v-model="client.codePostal" />
                </div>
                <div class="col-md-4">
                    <label for="gsm">Gsm</label>
                    <input type="text" class="form-control" id="client_gsm" v-model="client.gsm" />
                </div>
            </div>
            <div class="d-flex justify-content-between mt-4">
                <button type="submit" class="btn btn-primary" data-bs-toggle="modal"
                    data-bs-target="#modalEditIdentite">
                    Ajouter un client
                </button>
                <button type="submit" class="btn btn-primary">Rechercher</button>
            </div>

        </form>
    </div>

    <br />
    <div v-if="searchClient" class="client-section">
        <div class="cadre">
            <div>
                <h3>Résultat de la recherche</h3>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>Société</th>
                        <th>Nom</th>
                        <th>Prenom</th>
                        <th>Localité</th>
                        <th>Code postal</th>
                        <th>Gsm</th>
                        <th></th>
                    </tr>

                </thead>
                <tbody v-if="clients && clients.length">
                    <tr v-for="(client, index) in paginatedItems" :key="client.id">
                        <td>{{ client.societe }}</td>
                        <td>{{ client.nom }}</td>
                        <td>{{ client.prenom }}</td>
                        <td>{{ client.adresse.localite }}</td>
                        <td>{{ client.adresse.codePostal }}</td>
                        <td>{{ getCoordonnee('GSM', client.coordonnee) }}</td>
                        <td>
                            <div class="tab_outils">
                                <div>
                                    <a v-on:click="editClient(client.id)">
                                        <i class="material-icons"
                                            style="font-size:20px;color: cornflowerblue">visibility</i>
                                    </a>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tfoot v-else>
                    <tr>
                        <td colspan="7" class="emptyTableMessage">Aucun client trouvé</td>
                    </tr>
                </tfoot>
            </table>
            <div class="pagination">
                <a v-on:click="previousPage()" :disabled="currentPage === 1">
                    <i class="material-icons" style="font-size:24px;">keyboard_double_arrow_left</i>
                </a>
                <span>Page {{ currentPage }} sur {{ totalPages }}</span>
                <a v-on:click="nextPage()" :disabled="currentPage === totalPages">
                    <i class="material-icons" style="font-size:24px;">keyboard_double_arrow_right</i>
                </a>
            </div>
        </div>
    </div>

    <ClientEdit @saved="searchClients()" />

</template>

<script>
import Axios from '@/services/axios.service';
import PaginationService from '@/services/pagination.service';
import ClientEdit from './ClientEdit.vue';

export default {
    name: 'ClientIndex',
    mixins: [PaginationService],
    components: {
        ClientEdit,
    },
    data() {
        return {
            client: {
                nom: '',
                prenom: '',
                societe: '',
                gsm: '',
                localite: '',
                codePostal: '',
            },
            clients: [],
            clientEditId: null,
            searchClient: false
        };
    },
    props: {
        msg: String
    },
    mounted() {
        this.searchClients();
    },
    methods: {
        searchClients() {
            Axios.get('/identite')
                .then(res => {
                    const listeFiltree = this.filtersByForm(res.data);
                    this.items = listeFiltree;
                    this.clients = listeFiltree;
                    this.searchClient = true;
                })
                .catch(err => {
                    console.error('Erreur lors du chargement des clients :', err);
                });
        },
        filtersByForm(data) {
            let liste = data;
            if (this.client.nom) {
                liste = liste.filter(client =>
                    client.nom.toLowerCase().includes(this.client.nom.toLowerCase())
                );
            }
            if (this.client.prenom) {
                liste = liste.filter(client =>
                    client.prenom.toLowerCase().includes(this.client.prenom.toLowerCase())
                );
            }
            if (this.client.societe) {
                liste = liste.filter(client =>
                    client.societe.toLowerCase().includes(this.client.societe.toLowerCase())
                );
            }
            if (this.client.gsm) {
                liste = liste.filter(client =>
                    client.coordonnee.some(coord =>
                        coord.typeCoordonnee === 'GSM' &&
                        coord.information?.toLowerCase().includes(this.client.gsm.toLowerCase())
                    )
                );
            }
            if (this.client.localite) {
                liste = liste.filter(client =>
                    client.adresse?.localite?.toLowerCase().includes(this.client.localite.toLowerCase())
                );
            }
            if (this.client.codePostal) {
                const codePostalFilter = this.client.codePostal.toLowerCase();
                liste = liste.filter(client => {
                    const cp = client.adresse?.codePostal;
                    return cp && cp.toString().toLowerCase().includes(codePostalFilter);
                });
            }
            return liste;
        },
        editClient(id) {
            this.$router.push({ name: 'clientInfo', params: { id } })
        },
        getCoordonnee(type, coordonnee) {
            if (Array.isArray(coordonnee)) {
                const coord = coordonnee.find(c => c.typeCoordonnee === type);
                return coord ? coord.information : null;
            }
            return null;
        },
    }
}
</script>

<style scoped>
.emptyTableMessage {
    text-align: center;
    color: red
}
</style>
